import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";

import EntityFormPage from "../../../../components/EntityFormPage/EntityFormPage";
import { ToastContext } from "../../../../App";
import { useCreateUserMutation } from "../../../../redux/services/user";
import getSubdomain from "../../../../utils/getSubdomain";

import * as styles from "../ChefManagement.module.css";

const LIST_PATH = "/app/manager/chefs";

function ChefCreatePage() {
  const showToast = useContext(ToastContext);
  const navigate = useNavigate();

  const { control, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
    },
  });

  const [
    createChef,
    {
      isSuccess: isCreateChefSuccess,
      isError: isCreateChefError,
      error: createChefError,
    },
  ] = useCreateUserMutation();

  useEffect(() => {
    if (isCreateChefSuccess) {
      showToast("success", "Chef", "Chef created!");
      navigate(LIST_PATH);
    }
  }, [isCreateChefSuccess]);

  useEffect(() => {
    if (isCreateChefError) {
      showToast(
        "error",
        createChefError?.status,
        createChefError?.data?.message ||
          (createChefError?.data?.errors && "Incorrect data"),
      );
    }
  }, [isCreateChefError]);

  const onCreate = (data) => {
    const { name, email, phone, password } = data;
    createChef({
      subdomain: getSubdomain(),
      payload: {
        email,
        password,
        name,
        phone: `+1${phone}`,
        userRole: "chef",
      },
    });
  };

  return (
    <EntityFormPage
      title="New Chef"
      backTo={LIST_PATH}
      footer={
        <Button
          label="Save"
          type="submit"
          className={`p-button-success ${styles.saveBtn}`}
          onClick={handleSubmit(onCreate)}
        />
      }
    >
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Name</label>
              <InputText
                className={`w-full mb-3 ${styles.input}`}
                placeholder="Name"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Email</label>
              <InputText
                className={`w-full mb-3 ${styles.input}`}
                placeholder="Email"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="phone"
          control={control}
          rules={{
            required: "Enter your phone number",
            minLength: { value: 10, message: "Phone number is invalid" },
          }}
          render={({ field, fieldState }) => (
            <div className="field">
              <label>Phone Number</label>
              <div>
                <div className="p-inputgroup flex-1">
                  <span
                    className={`p-inputgroup-addon mb-3 ${styles.phonePrefix}`}
                  >
                    +1
                  </span>
                  <InputMask
                    className={`w-full mb-3 ${styles.inputPhone} ${
                      fieldState.invalid ? "p-invalid" : ""
                    }`}
                    placeholder="(999) 999-9999"
                    prefix="+1"
                    mask="(999) 999-9999"
                    unmask={true}
                    {...field}
                  />
                </div>
                {fieldState.error && (
                  <small className="p-error">{fieldState.error.message}</small>
                )}
              </div>
            </div>
          )}
        />

        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Password</label>
              <Password
                {...field}
                className={`w-full ${styles.password}`}
                inputClassName="w-full"
                placeholder="Password"
                toggleMask
                feedback={false}
              />
            </div>
          )}
        />

        <button type="submit" hidden />
      </form>
    </EntityFormPage>
  );
}

export default ChefCreatePage;
